var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTraining(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1279",
    "data-name": "Group 1279",
    transform: "translate(-6269 -2952)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_718",
    "data-name": "Path 718",
    d: "M6288.158,2959.136l-1.627-1.628.706-.706a.746.746,0,1,0-1.036-1.073l-.018.018-.706.707-1.628-1.628a2.762,2.762,0,0,0-3.808,0,2.693,2.693,0,0,0,0,3.807h0l1.628,1.627-4.4,4.4-1.628-1.627a2.758,2.758,0,0,0-3.807,0,2.692,2.692,0,0,0,0,3.806l0,0,1.627,1.627-.706.706a.746.746,0,0,0,1.036,1.073l.018-.018.707-.707,1.628,1.628a2.692,2.692,0,0,0,3.806,0h0a2.692,2.692,0,0,0,0-3.806h0l-1.627-1.628,4.4-4.4,1.627,1.627a2.69,2.69,0,0,0,3.806,0h0a2.692,2.692,0,0,0,0-3.805l0,0Zm-8.906,10.108a1.19,1.19,0,0,1-.352.848,1.226,1.226,0,0,1-1.7,0l-4.31-4.31a1.2,1.2,0,0,1,1.7-1.7l4.309,4.31a1.194,1.194,0,0,1,.352.85Zm7.852-7.355a1.229,1.229,0,0,1-1.7,0l-4.31-4.31a1.2,1.2,0,0,1,1.7-1.7h0l4.31,4.31a1.2,1.2,0,0,1,0,1.7Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_553",
    "data-name": "Rectangle 553",
    width: 22,
    height: 22,
    transform: "translate(6269 2952)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTraining);
export default __webpack_public_path__ + "static/media/icon-training.3ca1ac3036a00fbbae13df07bea22a9f.svg";
export { ForwardRef as ReactComponent };